var _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerStr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 96,
    viewBox: "0 0 3 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.75,
    y1: -4.37114e-8,
    x2: 1.75,
    y2: 96,
    stroke: "url(#paint0_linear_4969_38400)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4969_38400",
    x1: 0.25,
    y1: 2.18557e-8,
    x2: 0.250004,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6181",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500015,
    stopColor: "#4C6181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C6181",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerStr);
export default __webpack_public_path__ + "static/media/divider-str.8dc91b3623cea34ba25d81d68a47de42.svg";
export { ForwardRef as ReactComponent };